// extracted by mini-css-extract-plugin
export default {"errorList":"errorList--lTeMY","mainError":"mainError--Iv7Is","errorInfoBox":"errorInfoBox--wiMtN","comparison":"comparison--EFFHP"};